import { render, staticRenderFns } from "./print.vue?vue&type=template&id=c2b1e458"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports